import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/features/auth';

function ResetPassword() {
  const { token, intent } = Route.useSearch();
  return <ResetPasswordPage token={token} intent={intent} />;
}

/**
 * Target of both the reset and the welcome email. No session redirect: the link must work for
 * someone who is signed in elsewhere, and the backend ends every session on success anyway.
 */
export const Route = createFileRoute('/(public)/reset-password')({
  validateSearch: z.object({
    token: z.string().min(1).optional(),
    intent: z.literal('welcome').optional().catch(undefined),
  }),
  component: ResetPassword,
});
